export default {
  setAlertFlag (state:any, flag: boolean) {
    state.alertFlag = flag
  },
  setAlertMessage (state:any, msg: any) {
    state.message = msg
  },
  setErrorAlertFlag (state:any, flag: boolean) {
    state.errorAlertFlag = flag
  },
  setErrorAlertMessage (state:any, msg: string) {
    state.errorMessage = msg
  }
}
